/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/**
 * This file was auto-generated by `yarn ts-node scripts/apm/generateRequestsPatterns.ts`.
 * Do not make direct changes to the file.
 */
export const requests = {
  static: {
    GET: [
      { request: 'GET /api/v1/account', service: 'cp' },
      { request: 'GET /api/v1/all/_search', service: 'cp' },
      { request: 'GET /api/v1/authorization/roles', service: 'cp' },
      { request: 'GET /api/v1/deployments', service: 'cp' },
      { request: 'GET /api/v1/deployments/byok-configuration-parameters', service: 'cp' },
      { request: 'GET /api/v1/deployments/extensions', service: 'cp' },
      { request: 'GET /api/v1/deployments/templates', service: 'cp' },
      { request: 'GET /api/v1/deployments/traffic-filter/rulesets', service: 'cp' },
      { request: 'GET /api/v1/organizations', service: 'cp' },
      { request: 'GET /api/v1/phone-home/config', service: 'cp' },
      { request: 'GET /api/v1/phone-home/data', service: 'cp' },
      { request: 'GET /api/v1/platform/configuration/api_base_url', service: 'cp' },
      { request: 'GET /api/v1/platform/configuration/templates/deployments/global', service: 'cp' },
      { request: 'GET /api/v1/platform/license/eula', service: 'cp' },
      { request: 'GET /api/v1/saas/auth/mfa', service: 'cp' },
      { request: 'GET /api/v1/saas/auth/mfa/devices', service: 'cp' },
      { request: 'GET /api/v1/saas/billing/prices', service: 'cp' },
      { request: 'GET /api/v1/saas/providers', service: 'cp' },
      { request: 'GET /api/v1/saas/status', service: 'cp' },
      { request: 'GET /api/v1/saas/tiles/event', service: 'cp' },
      { request: 'GET /api/v1/saas/user', service: 'cp' },
      { request: 'GET /api/v1/saas/user/applications', service: 'cp' },
      { request: 'GET /api/v1/trusted-environments', service: 'cp' },
      { request: 'GET /api/v1/user', service: 'cp' },
      { request: 'GET /api/v1/users', service: 'cp' },
      { request: 'GET /api/v1/users/auth', service: 'cp' },
      { request: 'GET /api/v1/users/auth/keys', service: 'cp' },
      { request: 'GET /api/v1/users/auth/keys/_all', service: 'cp' },
      { request: 'GET /api/v1/users/auth/methods', service: 'cp' },
      { request: 'GET /api/v1/serverless/projects/elasticsearch', service: 'project' },
      { request: 'GET /api/v1/serverless/projects/observability', service: 'project' },
      { request: 'GET /api/v1/serverless/projects/security', service: 'project' },
      { request: 'GET /api/v1/serverless/clusters', service: 'cluster' },
      { request: 'GET /api/v1/serverless/regions', service: 'cluster' },
      { request: 'GET /api/v1/billing/statements', service: 'billing' },
      { request: 'GET /api/v1/costs', service: 'billing' },
      { request: 'GET /api/v1/costs/deployments', service: 'billing' },
      { request: 'GET /api/v1/costs/items', service: 'billing' },
      { request: 'GET /api/v1/prices', service: 'billing' },
      { request: 'GET /api/v1/prices/adjustment', service: 'billing' },
      { request: 'GET /api/v1/prices/base_prices', service: 'billing' },
      { request: 'GET /api/v1/prices/dnt', service: 'billing' },
      { request: 'GET /api/v1/prices/search', service: 'billing' },
      { request: 'GET /api/v2/billing/organizations/orgs_with_usage', service: 'billing' },
    ],
    POST: [
      { request: 'POST /api/v1/authorization/_check', service: 'cp' },
      { request: 'POST /api/v1/deployments', service: 'cp' },
      { request: 'POST /api/v1/deployments/_search', service: 'cp' },
      { request: 'POST /api/v1/deployments/eligible-remote-clusters', service: 'cp' },
      { request: 'POST /api/v1/deployments/extensions', service: 'cp' },
      { request: 'POST /api/v1/deployments/templates', service: 'cp' },
      { request: 'POST /api/v1/deployments/traffic-filter/rulesets', service: 'cp' },
      { request: 'POST /api/v1/organizations', service: 'cp' },
      { request: 'POST /api/v1/platform/license/eula/_accept', service: 'cp' },
      { request: 'POST /api/v1/saas/auth/_login', service: 'cp' },
      { request: 'POST /api/v1/saas/auth/_logout', service: 'cp' },
      { request: 'POST /api/v1/saas/auth/_refresh', service: 'cp' },
      { request: 'POST /api/v1/saas/auth/mfa/devices', service: 'cp' },
      { request: 'POST /api/v1/saas/auth/oauth/_callback', service: 'cp' },
      { request: 'POST /api/v1/saas/auth/sso/_callback', service: 'cp' },
      { request: 'POST /api/v1/saas/auth/sso/_find_idp', service: 'cp' },
      { request: 'POST /api/v1/saas/deployments/instant', service: 'cp' },
      { request: 'POST /api/v1/saas/marketplace/_activate', service: 'cp' },
      { request: 'POST /api/v1/saas/marketplace/_introspect', service: 'cp' },
      { request: 'POST /api/v1/saas/marketplace/_subscribe', service: 'cp' },
      { request: 'POST /api/v1/saas/user', service: 'cp' },
      { request: 'POST /api/v1/saas/user/_email', service: 'cp' },
      { request: 'POST /api/v1/saas/user/_password', service: 'cp' },
      { request: 'POST /api/v1/saas/user/_password_hash', service: 'cp' },
      { request: 'POST /api/v1/saas/user/_resend_verification', service: 'cp' },
      { request: 'POST /api/v1/saas/user/_reset-password', service: 'cp' },
      { request: 'POST /api/v1/saas/user/_subscription_level', service: 'cp' },
      { request: 'POST /api/v1/saas/user/_verify', service: 'cp' },
      { request: 'POST /api/v1/saas/user/feedback', service: 'cp' },
      { request: 'POST /api/v1/saas/user/mfa/_reset', service: 'cp' },
      { request: 'POST /api/v1/saas/user/trials/_extend', service: 'cp' },
      { request: 'POST /api/v1/saas/users', service: 'cp' },
      { request: 'POST /api/v1/saas/users/_invite', service: 'cp' },
      { request: 'POST /api/v1/saas/users/_resend_verification', service: 'cp' },
      { request: 'POST /api/v1/saas/users/_search', service: 'cp' },
      { request: 'POST /api/v1/saas/users/external/events/verify_email', service: 'cp' },
      { request: 'POST /api/v1/users', service: 'cp' },
      { request: 'POST /api/v1/users/auth/_logout', service: 'cp' },
      { request: 'POST /api/v1/users/auth/_refresh', service: 'cp' },
      { request: 'POST /api/v1/users/auth/keys', service: 'cp' },
      { request: 'POST /api/v1/serverless/projects/elasticsearch', service: 'project' },
      { request: 'POST /api/v1/serverless/projects/observability', service: 'project' },
      { request: 'POST /api/v1/serverless/projects/security', service: 'project' },
      { request: 'POST /api/v1/billing/ecu_prices', service: 'billing' },
      { request: 'POST /api/v1/billing/invoices/publish', service: 'billing' },
      { request: 'POST /api/v1/billing/line_item', service: 'billing' },
      { request: 'POST /api/v1/billing/line_item/cancel', service: 'billing' },
      { request: 'POST /api/v1/billing/line_item/check', service: 'billing' },
      { request: 'POST /api/v1/billing/line_item/extend', service: 'billing' },
      { request: 'POST /api/v1/billing/metering', service: 'billing' },
      { request: 'POST /api/v1/marketplace/azure/webhook/', service: 'billing' },
      { request: 'POST /api/v1/prices/bulk', service: 'billing' },
      { request: 'POST /api/v2/billing/costs/run_service', service: 'billing' },
      { request: 'POST /api/v2/marketplace/azure/webhook/', service: 'billing' },
    ],
    PUT: [
      { request: 'PUT /api/v1/account', service: 'cp' },
      { request: 'PUT /api/v1/phone-home/config', service: 'cp' },
      { request: 'PUT /api/v1/platform/configuration/api_base_url', service: 'cp' },
      { request: 'PUT /api/v1/saas/auth/mfa', service: 'cp' },
      { request: 'PUT /api/v1/saas/billing/lineitems/activate', service: 'cp' },
      { request: 'PUT /api/v1/saas/user/discovery_questions', service: 'cp' },
      { request: 'PUT /api/v1/saas/user/profile', service: 'cp' },
    ],
    DELETE: [
      { request: 'DELETE /api/v1/users/auth/keys', service: 'cp' },
      { request: 'DELETE /api/v1/users/auth/keys/_all', service: 'cp' },
    ],
    PATCH: [
      { request: 'PATCH /api/v1/account', service: 'cp' },
      { request: 'PATCH /api/v1/user', service: 'cp' },
    ],
  },
  dynamic: {
    GET: [
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/aliases\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/aliases/{alias}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/authentication\/_authenticate(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/authentication/_authenticate',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/billing\/costs\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/billing/costs/{organization_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/billing\/costs\/[^/]+\/charts(\?.*)?$/,
        request: 'GET /api/v1/billing/costs/{organization_id}/charts',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/billing\/costs\/[^/]+\/deployments(\?.*)?$/,
        request: 'GET /api/v1/billing/costs/{organization_id}/deployments',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/billing\/costs\/[^/]+\/deployments\/[^/]+\/charts(\?.*)?$/,
        request: 'GET /api/v1/billing/costs/{organization_id}/deployments/{deployment_id}/charts',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/billing\/costs\/[^/]+\/deployments\/[^/]+\/items(\?.*)?$/,
        request: 'GET /api/v1/billing/costs/{organization_id}/deployments/{deployment_id}/items',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/billing\/costs\/[^/]+\/items(\?.*)?$/,
        request: 'GET /api/v1/billing/costs/{organization_id}/items',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/comments\/[^/]+\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/comments/{resource_type}/{resource_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/comments\/[^/]+\/[^/]+\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/comments/{resource_type}/{resource_id}/{comment_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/deployments\/extensions\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/deployments/extensions/{extension_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/deployments\/templates\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/deployments/templates/{template_id}',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/deployments\/traffic-filter\/associations\/[^/]+\/[^/]+\/rulesets(\?.*)?$/,
        request:
          'GET /api/v1/deployments/traffic-filter/associations/{association_type}/{associated_entity_id}/rulesets',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/deployments\/traffic-filter\/link-ids(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/deployments/traffic-filter/link-ids',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/deployments\/traffic-filter\/rulesets\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/deployments/traffic-filter/rulesets/{ruleset_id}',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/deployments\/traffic-filter\/rulesets\/[^/]+\/associations(\?.*)?$/,
        request: 'GET /api/v1/deployments/traffic-filter/rulesets/{ruleset_id}/associations',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/deployments\/traffic-filter\/tokens\/[^/]+\/[^/]+\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/deployments/traffic-filter/tokens/{deployment_id}/{resource_kind}/{ref_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/deployments\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/deployments/{deployment_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/deployments\/[^/]+\/apm\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/deployments/{deployment_id}/apm/{ref_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/deployments\/[^/]+\/appsearch\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/deployments/{deployment_id}/appsearch/{ref_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/deployments\/[^/]+\/appsearch\/[^/]+\/read_only_mode(\?.*)?$/,
        request: 'GET /api/v1/deployments/{deployment_id}/appsearch/{ref_id}/read_only_mode',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/deployments\/[^/]+\/certificate-authority(\?.*)?$/,
        request: 'GET /api/v1/deployments/{deployment_id}/certificate-authority',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/deployments\/[^/]+\/elasticsearch\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/deployments/{deployment_id}/elasticsearch/{ref_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/deployments\/[^/]+\/elasticsearch\/[^/]+\/keystore(\?.*)?$/,
        request: 'GET /api/v1/deployments/{deployment_id}/elasticsearch/{ref_id}/keystore',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/deployments\/[^/]+\/elasticsearch\/[^/]+\/logs\/_download(\?.*)?$/,
        request: 'GET /api/v1/deployments/{deployment_id}/elasticsearch/{ref_id}/logs/_download',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/deployments\/[^/]+\/elasticsearch\/[^/]+\/logs\/_search(\?.*)?$/,
        request: 'GET /api/v1/deployments/{deployment_id}/elasticsearch/{ref_id}/logs/_search',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/deployments\/[^/]+\/elasticsearch\/[^/]+\/metrics(\?.*)?$/,
        request: 'GET /api/v1/deployments/{deployment_id}/elasticsearch/{ref_id}/metrics',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/deployments\/[^/]+\/elasticsearch\/[^/]+\/performance-metrics(\?.*)?$/,
        request:
          'GET /api/v1/deployments/{deployment_id}/elasticsearch/{ref_id}/performance-metrics',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/deployments\/[^/]+\/elasticsearch\/[^/]+\/remote-clusters(\?.*)?$/,
        request: 'GET /api/v1/deployments/{deployment_id}/elasticsearch/{ref_id}/remote-clusters',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/deployments\/[^/]+\/elasticsearch\/[^/]+\/snapshot(\?.*)?$/,
        request: 'GET /api/v1/deployments/{deployment_id}/elasticsearch/{ref_id}/snapshot',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/deployments\/[^/]+\/elasticsearch\/[^/]+\/snapshot\/dependency(\?.*)?$/,
        request:
          'GET /api/v1/deployments/{deployment_id}/elasticsearch/{ref_id}/snapshot/dependency',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/deployments\/[^/]+\/elasticsearch\/[^/]+\/users(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/deployments/{deployment_id}/elasticsearch/{ref_id}/users',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/deployments\/[^/]+\/elasticsearch\/[^/]+\/users\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/deployments/{deployment_id}/elasticsearch/{ref_id}/users/{user_name}',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/deployments\/[^/]+\/enterprise_search\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/deployments/{deployment_id}/enterprise_search/{ref_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/deployments\/[^/]+\/health(\?.*)?$/,
        request: 'GET /api/v1/deployments/{deployment_id}/health',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/deployments\/[^/]+\/heap_dumps(\?.*)?$/,
        request: 'GET /api/v1/deployments/{deployment_id}/heap_dumps',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/deployments\/[^/]+\/integrations_server\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/deployments/{deployment_id}/integrations_server/{ref_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/deployments\/[^/]+\/kibana\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/deployments/{deployment_id}/kibana/{ref_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/deployments\/[^/]+\/migrate_template(\?.*)?$/,
        request: 'GET /api/v1/deployments/{deployment_id}/migrate_template',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/deployments\/[^/]+\/upgrade_assistant\/status(\?.*)?$/,
        request: 'GET /api/v1/deployments/{deployment_id}/upgrade_assistant/status',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/activity\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/deployments/{deployment_id}/{resource_kind}/{ref_id}/activity/{attempt_id}',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/instances\/[^/]+\/heap_dump\/_download(\?.*)?$/,
        request:
          'GET /api/v1/deployments/{deployment_id}/{resource_kind}/{ref_id}/instances/{instance_id}/heap_dump/_download',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/proxy\/.*(\?.*)?$/,
        request:
          'GET /api/v1/deployments/{deployment_id}/{resource_kind}/{ref_id}/proxy/{proxy_path}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/health(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/health',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/organizations\/invitations\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/organizations/invitations/{invitation_token}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/organizations\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/organizations/{organization_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/organizations\/[^/]+\/audit_logs(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/organizations/{organization_id}/audit_logs',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/organizations\/[^/]+\/configuration(\?.*)?$/,
        request: 'GET /api/v1/organizations/{organization_id}/configuration',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/organizations\/[^/]+\/domains(\?.*)?$/,
        request: 'GET /api/v1/organizations/{organization_id}/domains',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/organizations\/[^/]+\/idp(\?.*)?$/,
        request: 'GET /api/v1/organizations/{organization_id}/idp',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/organizations\/[^/]+\/idp\/metadata(\?.*)?$/,
        request: 'GET /api/v1/organizations/{organization_id}/idp/metadata',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/organizations\/[^/]+\/invitations(\?.*)?$/,
        request: 'GET /api/v1/organizations/{organization_id}/invitations',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/organizations\/[^/]+\/members(\?.*)?$/,
        request: 'GET /api/v1/organizations/{organization_id}/members',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/organizations\/[^/]+\/role_mappings(\?.*)?$/,
        request: 'GET /api/v1/organizations/{organization_id}/role_mappings',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/azure\/privatelink\/linkids(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/configuration/azure/privatelink/linkids',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/azure\/privatelink\/linkids\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/configuration/azure/privatelink/linkids/{name-and-id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/feature-flags(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/configuration/feature-flags',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/feature-flags\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/configuration/feature-flags/{feature_flag}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/instances(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/configuration/instances',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/instances\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/configuration/instances/{id}',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/networking\/deployment_domain_name(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/configuration/networking/deployment_domain_name',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/networking\/deployment_domain_name\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/configuration/networking/deployment_domain_name/{resource_kind}',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/deployment(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/configuration/security/deployment',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/enrollment-tokens(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/configuration/security/enrollment-tokens',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/extra_certs(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/configuration/security/extra_certs',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/extra_certs\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/configuration/security/extra_certs/{cert_id}',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/realms(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/configuration/security/realms',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/realms\/active-directory\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/configuration/security/realms/active-directory/{realm_id}',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/realms\/ldap\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/configuration/security/realms/ldap/{realm_id}',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/realms\/saml\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/configuration/security/realms/saml/{realm_id}',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/service-accounts(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/configuration/security/service-accounts',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/service-accounts\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/configuration/security/service-accounts/{user_id}',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/service-accounts\/[^/]+\/keys(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/configuration/security/service-accounts/{user_id}/keys',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/tls\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/configuration/security/tls/{service_name}',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/shared-files\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/configuration/shared-files/{shared_file}',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/snapshots\/repositories(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/configuration/snapshots/repositories',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/snapshots\/repositories\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/configuration/snapshots/repositories/{repository_name}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/store(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/configuration/store',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/store\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/configuration/store/{config_option_id}',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/trust-relationships(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/configuration/trust-relationships',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/configuration\/trust-relationships\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/configuration/trust-relationships/{trust_relationship_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/platform\/health(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/health',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/platform\/health\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/health/{health_check_name}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/adminconsoles(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/infrastructure/adminconsoles',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/adminconsoles\/[^/]+\/logging_settings(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/infrastructure/adminconsoles/{adminconsole_id}/logging_settings',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/allocators(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/infrastructure/allocators',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/allocators\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/infrastructure/allocators/{allocator_id}',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/allocators\/[^/]+\/logging_settings(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/infrastructure/allocators/{allocator_id}/logging_settings',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/allocators\/[^/]+\/metadata(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/infrastructure/allocators/{allocator_id}/metadata',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/allocators\/[^/]+\/settings(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/infrastructure/allocators/{allocator_id}/settings',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/blueprinter\/roles(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/infrastructure/blueprinter/roles',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/blueprinter\/roles\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/infrastructure/blueprinter/roles/{blueprinter_role_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/constructors(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/infrastructure/constructors',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/constructors\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/infrastructure/constructors/{constructor_id}',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/constructors\/[^/]+\/logging_settings(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/infrastructure/constructors/{constructor_id}/logging_settings',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/container-sets(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/infrastructure/container-sets',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/container-sets\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/infrastructure/container-sets/{containerset_id}',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/container-sets\/[^/]+\/containers(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/infrastructure/container-sets/{containerset_id}/containers',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/container-sets\/[^/]+\/containers\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/infrastructure/container-sets/{containerset_id}/containers/{container_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/coordinators(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/infrastructure/coordinators',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/coordinators\/candidates(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/infrastructure/coordinators/candidates',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/coordinators\/candidates\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/infrastructure/coordinators/candidates/{coordinator_candidate_id}',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/coordinators\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/infrastructure/coordinators/{coordinator_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/proxies(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/infrastructure/proxies',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/proxies\/filtered-groups\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/infrastructure/proxies/filtered-groups/{proxies_filtered_group_id}',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/proxies\/filtered-groups\/[^/]+\/health(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/infrastructure/proxies/filtered-groups/{proxies_filtered_group_id}/health',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/proxies\/health(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/infrastructure/proxies/health',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/proxies\/settings(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/infrastructure/proxies/settings',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/proxies\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/infrastructure/proxies/{proxy_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/runners(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/infrastructure/runners',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/runners\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/infrastructure/runners/{runner_id}',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/runners\/[^/]+\/logging_settings(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/infrastructure/runners/{runner_id}/logging_settings',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/services\/accounter\/health(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/infrastructure/services/accounter/health',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/services\/mailer\/health(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/infrastructure/services/mailer/health',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/services\/scaler\/health(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/infrastructure/services/scaler/health',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/platform\/license(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/license',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/platform\/resources\/aws\/s3\/accounts(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/platform/resources/aws/s3/accounts',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/resources\/aws\/s3\/accounts\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/resources/aws/s3/accounts/{account_name}',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/platform\/resources\/[^/]+\/[^/]+\/health(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/platform/resources/{cloud_service}/{storage_service}/health',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/saas\/auth\/sso\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/saas/auth/sso/{login_identifier}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/saas\/billing\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/saas/billing/{organization_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/saas\/billing\/[^/]+\/features(\?.*)?$/,
        request: 'GET /api/v1/saas/billing/{organization_id}/features',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/saas\/billing\/[^/]+\/history(\?.*)?$/,
        request: 'GET /api/v1/saas/billing/{organization_id}/history',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/saas\/billing\/[^/]+\/history\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/saas/billing/{organization_id}/history/{statement_number}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/saas\/billing\/[^/]+\/lineitems(\?.*)?$/,
        request: 'GET /api/v1/saas/billing/{organization_id}/lineitems',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/saas\/billing\/[^/]+\/marketplaces\/azure\/subscription(\?.*)?$/,
        request: 'GET /api/v1/saas/billing/{organization_id}/marketplaces/azure/subscription',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/saas\/billing\/[^/]+\/prepaids(\?.*)?$/,
        request: 'GET /api/v1/saas/billing/{organization_id}/prepaids',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/saas\/inappchat\/token(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/saas/inappchat/token',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/saas\/organizations\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/saas/organizations/{organization_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/saas\/portal\/checkout\/_init(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/saas/portal/checkout/_init',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/saas\/tiles\/blog\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/saas/tiles/blog/{category}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/saas\/users\/external\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/saas/users/external/{email}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/saas\/users\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/saas/users/{user_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/saas\/users\/[^/]+\/_password_params(\?.*)?$/,
        request: 'GET /api/v1/saas/users/{user_id}/_password_params',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/saas\/users\/[^/]+\/auth\/mfa(\?.*)?$/,
        request: 'GET /api/v1/saas/users/{user_id}/auth/mfa',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/saas\/users\/[^/]+\/auth\/mfa\/devices(\?.*)?$/,
        request: 'GET /api/v1/saas/users/{user_id}/auth/mfa/devices',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/saas\/users\/[^/]+\/auth\/okta\/groups(\?.*)?$/,
        request: 'GET /api/v1/saas/users/{user_id}/auth/okta/groups',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/saas\/users\/[^/]+\/email\/[^/]+\/suppressions(\?.*)?$/,
        request: 'GET /api/v1/saas/users/{user_id}/email/{email_domain}/suppressions',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/stack\/instance-types(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/stack/instance-types',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/stack\/versions(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/stack/versions',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/stack\/versions\/access(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/stack/versions/access',
        service: 'cp',
      },
      {
        pattern:
          /^GET \/api\/v1\/regions\/[^/]+\/stack\/versions\/access\/organizations\/[^/]+(\?.*)?$/,
        request:
          'GET /api/v1/regions/{region_id}/stack/versions/access/organizations/{organization_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/stack\/versions\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/stack/versions/{version}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/users\/auth\/keys\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/users/auth/keys/{api_key_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/users\/auth\/saml\/_init(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/users/auth/saml/_init',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/users\/[^/]+\/auth\/keys(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/users/{user_id}/auth/keys',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/users\/[^/]+\/auth\/keys\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/users/{user_id}/auth/keys/{api_key_id}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/regions\/[^/]+\/users\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/regions/{region_id}/users/{user_name}',
        service: 'cp',
      },
      {
        pattern: /^GET \/api\/v1\/serverless\/projects\/elasticsearch\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/serverless/projects/elasticsearch/{id}',
        service: 'project',
      },
      {
        pattern: /^GET \/api\/v1\/serverless\/projects\/elasticsearch\/[^/]+\/roles(\?.*)?$/,
        request: 'GET /api/v1/serverless/projects/elasticsearch/{id}/roles',
        service: 'project',
      },
      {
        pattern: /^GET \/api\/v1\/serverless\/projects\/elasticsearch\/[^/]+\/status(\?.*)?$/,
        request: 'GET /api/v1/serverless/projects/elasticsearch/{id}/status',
        service: 'project',
      },
      {
        pattern: /^GET \/api\/v1\/serverless\/projects\/observability\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/serverless/projects/observability/{id}',
        service: 'project',
      },
      {
        pattern: /^GET \/api\/v1\/serverless\/projects\/observability\/[^/]+\/roles(\?.*)?$/,
        request: 'GET /api/v1/serverless/projects/observability/{id}/roles',
        service: 'project',
      },
      {
        pattern: /^GET \/api\/v1\/serverless\/projects\/observability\/[^/]+\/status(\?.*)?$/,
        request: 'GET /api/v1/serverless/projects/observability/{id}/status',
        service: 'project',
      },
      {
        pattern: /^GET \/api\/v1\/serverless\/projects\/security\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/serverless/projects/security/{id}',
        service: 'project',
      },
      {
        pattern: /^GET \/api\/v1\/serverless\/projects\/security\/[^/]+\/roles(\?.*)?$/,
        request: 'GET /api/v1/serverless/projects/security/{id}/roles',
        service: 'project',
      },
      {
        pattern: /^GET \/api\/v1\/serverless\/projects\/security\/[^/]+\/status(\?.*)?$/,
        request: 'GET /api/v1/serverless/projects/security/{id}/status',
        service: 'project',
      },
      {
        pattern: /^GET \/api\/v1\/serverless\/regions\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/serverless/regions/{id}',
        service: 'cluster',
      },
      {
        pattern: /^GET \/api\/v1\/billing\/jobs\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/billing/jobs/{id}',
        service: 'billing',
      },
      {
        pattern: /^GET \/api\/v1\/billing\/organization\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/billing/organization/{organization_id}',
        service: 'billing',
      },
      {
        pattern: /^GET \/api\/v1\/billing\/organization\/[^/]+\/entitlements(\?.*)?$/,
        request: 'GET /api/v1/billing/organization/{organization_id}/entitlements',
        service: 'billing',
      },
      {
        pattern: /^GET \/api\/v1\/billing\/organization\/[^/]+\/history(\?.*)?$/,
        request: 'GET /api/v1/billing/organization/{organization_id}/history',
        service: 'billing',
      },
      {
        pattern: /^GET \/api\/v1\/billing\/organization\/[^/]+\/history\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/billing/organization/{organization_id}/history/{statement_number}',
        service: 'billing',
      },
      {
        pattern: /^GET \/api\/v1\/billing\/organization\/[^/]+\/line_items(\?.*)?$/,
        request: 'GET /api/v1/billing/organization/{organization_id}/line_items',
        service: 'billing',
      },
      {
        pattern: /^GET \/api\/v1\/billing\/organization\/[^/]+\/paid_in_full(\?.*)?$/,
        request: 'GET /api/v1/billing/organization/{organization_id}/paid_in_full',
        service: 'billing',
      },
      {
        pattern: /^GET \/api\/v1\/billing\/organization\/[^/]+\/payment_details(\?.*)?$/,
        request: 'GET /api/v1/billing/organization/{organization_id}/payment_details',
        service: 'billing',
      },
      {
        pattern: /^GET \/api\/v1\/billing\/organization\/[^/]+\/prepaids(\?.*)?$/,
        request: 'GET /api/v1/billing/organization/{organization_id}/prepaids',
        service: 'billing',
      },
      {
        pattern: /^GET \/api\/v1\/billing\/organization\/[^/]+\/receipt_status(\?.*)?$/,
        request: 'GET /api/v1/billing/organization/{organization_id}/receipt_status',
        service: 'billing',
      },
      {
        pattern: /^GET \/api\/v1\/costs\/deployments\/[^/]+(\?.*)?$/,
        request: 'GET /api/v1/costs/deployments/{deployment_id}',
        service: 'billing',
      },
      {
        pattern: /^GET \/api\/v1\/marketplace\/aws\/[^/]+\/contracts(\?.*)?$/,
        request: 'GET /api/v1/marketplace/aws/{organization_id}/contracts',
        service: 'billing',
      },
      {
        pattern: /^GET \/api\/v1\/marketplace\/azure\/[^/]+\/subscription(\?.*)?$/,
        request: 'GET /api/v1/marketplace/azure/{organization_id}/subscription',
        service: 'billing',
      },
      {
        pattern: /^GET \/api\/v1\/marketplace\/azure\/[^/]+\/contracts(\?.*)?$/,
        request: 'GET /api/v1/marketplace/azure/{user_id}/contracts',
        service: 'billing',
      },
      {
        pattern: /^GET \/api\/v1\/prices\/organization\/[^/]+\/uplifts(\?.*)?$/,
        request: 'GET /api/v1/prices/organization/{organization_id}/uplifts',
        service: 'billing',
      },
      {
        pattern: /^GET \/api\/v2\/billing\/instances\/[^/]+\/[^/]+(\?.*)?$/,
        request: 'GET /api/v2/billing/instances/{instance_type}/{instance_id}',
        service: 'billing',
      },
      {
        pattern: /^GET \/api\/v2\/billing\/organization\/[^/]+(\?.*)?$/,
        request: 'GET /api/v2/billing/organization/{organization_id}',
        service: 'billing',
      },
      {
        pattern: /^GET \/api\/v2\/billing\/organizations\/[^/]+\/charts(\?.*)?$/,
        request: 'GET /api/v2/billing/organizations/{organization_id}/charts',
        service: 'billing',
      },
      {
        pattern: /^GET \/api\/v2\/billing\/organizations\/[^/]+\/costs\/instances(\?.*)?$/,
        request: 'GET /api/v2/billing/organizations/{organization_id}/costs/instances',
        service: 'billing',
      },
      {
        pattern:
          /^GET \/api\/v2\/billing\/organizations\/[^/]+\/costs\/instances\/[^/]+\/items(\?.*)?$/,
        request:
          'GET /api/v2/billing/organizations/{organization_id}/costs/instances/{instance_id}/items',
        service: 'billing',
      },
      {
        pattern: /^GET \/api\/v2\/billing\/organizations\/[^/]+\/costs\/items(\?.*)?$/,
        request: 'GET /api/v2/billing/organizations/{organization_id}/costs/items',
        service: 'billing',
      },
      {
        pattern: /^GET \/api\/v2\/billing\/organizations\/[^/]+\/instances\/[^/]+\/charts(\?.*)?$/,
        request:
          'GET /api/v2/billing/organizations/{organization_id}/instances/{instance_id}/charts',
        service: 'billing',
      },
    ],
    POST: [
      {
        pattern: /^POST \/api\/v1\/regions\/[^/]+\/comments\/[^/]+\/[^/]+(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/comments/{resource_type}/{resource_id}',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/regions\/[^/]+\/deployments\/_resync(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/deployments/_resync',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/deployments\/extensions\/[^/]+(\?.*)?$/,
        request: 'POST /api/v1/deployments/extensions/{extension_id}',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/deployments\/traffic-filter\/link-ids\/_claim(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/deployments/traffic-filter/link-ids/_claim',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/deployments\/traffic-filter\/link-ids\/_unclaim(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/deployments/traffic-filter/link-ids/_unclaim',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/deployments\/traffic-filter\/rulesets\/[^/]+\/associations(\?.*)?$/,
        request: 'POST /api/v1/deployments/traffic-filter/rulesets/{ruleset_id}/associations',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/regions\/[^/]+\/deployments\/[^/]+\/_migrate(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/deployments/{deployment_id}/_migrate',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/regions\/[^/]+\/deployments\/[^/]+\/_notify-revoked-key(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/deployments/{deployment_id}/_notify-revoked-key',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/deployments\/[^/]+\/_restore(\?.*)?$/,
        request: 'POST /api/v1/deployments/{deployment_id}/_restore',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/regions\/[^/]+\/deployments\/[^/]+\/_resync(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/deployments/{deployment_id}/_resync',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/deployments\/[^/]+\/_shutdown(\?.*)?$/,
        request: 'POST /api/v1/deployments/{deployment_id}/_shutdown',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/deployments\/[^/]+\/apm\/[^/]+\/_reset-token(\?.*)?$/,
        request: 'POST /api/v1/deployments/{deployment_id}/apm/{ref_id}/_reset-token',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/deployments\/[^/]+\/elasticsearch\/[^/]+\/_enable-ccr(\?.*)?$/,
        request: 'POST /api/v1/deployments/{deployment_id}/elasticsearch/{ref_id}/_enable-ccr',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/deployments\/[^/]+\/elasticsearch\/[^/]+\/_enable-ilm(\?.*)?$/,
        request: 'POST /api/v1/deployments/{deployment_id}/elasticsearch/{ref_id}/_enable-ilm',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/deployments\/[^/]+\/elasticsearch\/[^/]+\/_enable-slm(\?.*)?$/,
        request: 'POST /api/v1/deployments/{deployment_id}/elasticsearch/{ref_id}/_enable-slm',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/deployments\/[^/]+\/elasticsearch\/[^/]+\/_lock(\?.*)?$/,
        request: 'POST /api/v1/deployments/{deployment_id}/elasticsearch/{ref_id}/_lock',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/deployments\/[^/]+\/elasticsearch\/[^/]+\/_reset-password(\?.*)?$/,
        request: 'POST /api/v1/deployments/{deployment_id}/elasticsearch/{ref_id}/_reset-password',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/deployments\/[^/]+\/elasticsearch\/[^/]+\/_restart(\?.*)?$/,
        request: 'POST /api/v1/deployments/{deployment_id}/elasticsearch/{ref_id}/_restart',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/deployments\/[^/]+\/elasticsearch\/[^/]+\/_shutdown(\?.*)?$/,
        request: 'POST /api/v1/deployments/{deployment_id}/elasticsearch/{ref_id}/_shutdown',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/deployments\/[^/]+\/elasticsearch\/[^/]+\/eligible-remote-clusters(\?.*)?$/,
        request:
          'POST /api/v1/deployments/{deployment_id}/elasticsearch/{ref_id}/eligible-remote-clusters',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/deployments\/[^/]+\/elasticsearch\/[^/]+\/instances\/[^/]+\/_move(\?.*)?$/,
        request:
          'POST /api/v1/deployments/{deployment_id}/elasticsearch/{ref_id}/instances/{instance_ids}/_move',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/deployments\/[^/]+\/[^/]+\/[^/]+\/_restore(\?.*)?$/,
        request:
          'POST /api/v1/regions/{region_id}/deployments/{deployment_id}/{resource_kind}/{ref_id}/_restore',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/diagnostics\/_capture(\?.*)?$/,
        request:
          'POST /api/v1/deployments/{deployment_id}/{resource_kind}/{ref_id}/diagnostics/_capture',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/instances\/_start(\?.*)?$/,
        request:
          'POST /api/v1/deployments/{deployment_id}/{resource_kind}/{ref_id}/instances/_start',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/instances\/_stop(\?.*)?$/,
        request:
          'POST /api/v1/deployments/{deployment_id}/{resource_kind}/{ref_id}/instances/_stop',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/instances\/maintenance-mode\/_start(\?.*)?$/,
        request:
          'POST /api/v1/deployments/{deployment_id}/{resource_kind}/{ref_id}/instances/maintenance-mode/_start',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/instances\/maintenance-mode\/_stop(\?.*)?$/,
        request:
          'POST /api/v1/deployments/{deployment_id}/{resource_kind}/{ref_id}/instances/maintenance-mode/_stop',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/instances\/[^/]+\/_start(\?.*)?$/,
        request:
          'POST /api/v1/deployments/{deployment_id}/{resource_kind}/{ref_id}/instances/{instance_ids}/_start',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/instances\/[^/]+\/_stop(\?.*)?$/,
        request:
          'POST /api/v1/deployments/{deployment_id}/{resource_kind}/{ref_id}/instances/{instance_ids}/_stop',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/instances\/[^/]+\/maintenance-mode\/_start(\?.*)?$/,
        request:
          'POST /api/v1/deployments/{deployment_id}/{resource_kind}/{ref_id}/instances/{instance_ids}/maintenance-mode/_start',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/instances\/[^/]+\/maintenance-mode\/_stop(\?.*)?$/,
        request:
          'POST /api/v1/deployments/{deployment_id}/{resource_kind}/{ref_id}/instances/{instance_ids}/maintenance-mode/_stop',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/instances\/[^/]+\/heap_dump\/_capture(\?.*)?$/,
        request:
          'POST /api/v1/deployments/{deployment_id}/{resource_kind}/{ref_id}/instances/{instance_id}/heap_dump/_capture',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/instances\/[^/]+\/thread_dump\/_capture(\?.*)?$/,
        request:
          'POST /api/v1/deployments/{deployment_id}/{resource_kind}/{ref_id}/instances/{instance_id}/thread_dump/_capture',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/metadata\/raw(\?.*)?$/,
        request: 'POST /api/v1/deployments/{deployment_id}/{resource_kind}/{ref_id}/metadata/raw',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/proxy\/.*(\?.*)?$/,
        request:
          'POST /api/v1/deployments/{deployment_id}/{resource_kind}/{ref_id}/proxy/{proxy_path}',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/_restart(\?.*)?$/,
        request:
          'POST /api/v1/deployments/{deployment_id}/{stateless_resource_kind}/{ref_id}/_restart',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/_shutdown(\?.*)?$/,
        request:
          'POST /api/v1/deployments/{deployment_id}/{stateless_resource_kind}/{ref_id}/_shutdown',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/_upgrade(\?.*)?$/,
        request:
          'POST /api/v1/deployments/{deployment_id}/{stateless_resource_kind}/{ref_id}/_upgrade',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/organizations\/invitations\/[^/]+\/_accept(\?.*)?$/,
        request: 'POST /api/v1/organizations/invitations/{invitation_token}/_accept',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/regions\/[^/]+\/organizations\/[^/]+\/audit_logs(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/organizations/{organization_id}/audit_logs',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/organizations\/[^/]+\/domains\/_generate_verification_code(\?.*)?$/,
        request: 'POST /api/v1/organizations/{organization_id}/domains/_generate_verification_code',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/organizations\/[^/]+\/domains\/_verify(\?.*)?$/,
        request: 'POST /api/v1/organizations/{organization_id}/domains/_verify',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/organizations\/[^/]+\/invitations(\?.*)?$/,
        request: 'POST /api/v1/organizations/{organization_id}/invitations',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/organizations\/[^/]+\/members(\?.*)?$/,
        request: 'POST /api/v1/organizations/{organization_id}/members',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/configuration\/azure\/privatelink\/linkids\/[^/]+\/_refresh(\?.*)?$/,
        request:
          'POST /api/v1/regions/{region_id}/platform/configuration/azure/privatelink/linkids/{name-and-id}/_refresh',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/regions\/[^/]+\/platform\/configuration\/instances(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/platform/configuration/instances',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/deployment(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/platform/configuration/security/deployment',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/deployment\/_publish_idp_metadata(\?.*)?$/,
        request:
          'POST /api/v1/regions/{region_id}/platform/configuration/security/deployment/_publish_idp_metadata',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/enrollment-tokens(\?.*)?$/,
        request:
          'POST /api/v1/regions/{region_id}/platform/configuration/security/enrollment-tokens',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/realms\/_reorder(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/platform/configuration/security/realms/_reorder',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/realms\/active-directory(\?.*)?$/,
        request:
          'POST /api/v1/regions/{region_id}/platform/configuration/security/realms/active-directory',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/realms\/ldap(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/platform/configuration/security/realms/ldap',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/realms\/saml(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/platform/configuration/security/realms/saml',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/service-accounts(\?.*)?$/,
        request:
          'POST /api/v1/regions/{region_id}/platform/configuration/security/service-accounts',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/service-accounts\/[^/]+\/keys(\?.*)?$/,
        request:
          'POST /api/v1/regions/{region_id}/platform/configuration/security/service-accounts/{user_id}/keys',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/tls\/[^/]+(\?.*)?$/,
        request:
          'POST /api/v1/regions/{region_id}/platform/configuration/security/tls/{service_name}',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/regions\/[^/]+\/platform\/configuration\/store\/[^/]+(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/platform/configuration/store/{config_option_id}',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/configuration\/trust-relationships(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/platform/configuration/trust-relationships',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/adminconsoles\/_reindex(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/platform/infrastructure/adminconsoles/_reindex',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/allocators\/_resync(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/platform/infrastructure/allocators/_resync',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/allocators\/[^/]+\/_resync(\?.*)?$/,
        request:
          'POST /api/v1/regions/{region_id}/platform/infrastructure/allocators/{allocator_id}/_resync',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/allocators\/[^/]+\/clusters\/_move(\?.*)?$/,
        request:
          'POST /api/v1/regions/{region_id}/platform/infrastructure/allocators/{allocator_id}/clusters/_move',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/allocators\/[^/]+\/clusters\/[^/]+\/_move(\?.*)?$/,
        request:
          'POST /api/v1/regions/{region_id}/platform/infrastructure/allocators/{allocator_id}/clusters/{cluster_type}/_move',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/allocators\/[^/]+\/maintenance-mode\/_start(\?.*)?$/,
        request:
          'POST /api/v1/regions/{region_id}/platform/infrastructure/allocators/{allocator_id}/maintenance-mode/_start',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/allocators\/[^/]+\/maintenance-mode\/_stop(\?.*)?$/,
        request:
          'POST /api/v1/regions/{region_id}/platform/infrastructure/allocators/{allocator_id}/maintenance-mode/_stop',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/blueprinter\/roles(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/platform/infrastructure/blueprinter/roles',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/constructors\/_resync(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/platform/infrastructure/constructors/_resync',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/constructors\/[^/]+\/_resync(\?.*)?$/,
        request:
          'POST /api/v1/regions/{region_id}/platform/infrastructure/constructors/{constructor_id}/_resync',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/constructors\/[^/]+\/maintenance-mode\/_start(\?.*)?$/,
        request:
          'POST /api/v1/regions/{region_id}/platform/infrastructure/constructors/{constructor_id}/maintenance-mode/_start',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/constructors\/[^/]+\/maintenance-mode\/_stop(\?.*)?$/,
        request:
          'POST /api/v1/regions/{region_id}/platform/infrastructure/constructors/{constructor_id}/maintenance-mode/_stop',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/container-sets(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/platform/infrastructure/container-sets',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/container-sets\/[^/]+\/containers(\?.*)?$/,
        request:
          'POST /api/v1/regions/{region_id}/platform/infrastructure/container-sets/{containerset_id}/containers',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/coordinators\/candidates\/[^/]+\/_promote(\?.*)?$/,
        request:
          'POST /api/v1/regions/{region_id}/platform/infrastructure/coordinators/candidates/{coordinator_candidate_id}/_promote',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/coordinators\/[^/]+\/_demote(\?.*)?$/,
        request:
          'POST /api/v1/regions/{region_id}/platform/infrastructure/coordinators/{coordinator_id}/_demote',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/proxies\/filtered-groups(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/platform/infrastructure/proxies/filtered-groups',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/runners\/_resync(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/platform/infrastructure/runners/_resync',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/runners\/_search(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/platform/infrastructure/runners/_search',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/runners\/[^/]+\/_resync(\?.*)?$/,
        request:
          'POST /api/v1/regions/{region_id}/platform/infrastructure/runners/{runner_id}/_resync',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/platform\/resources\/aws\/s3\/accounts\/[^/]+(\?.*)?$/,
        request:
          'POST /api/v1/regions/{region_id}/platform/resources/aws/s3/accounts/{account_name}',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/regions\/[^/]+\/saas\/auth\/heroku\/_callback(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/saas/auth/heroku/_callback',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/saas\/auth\/mfa\/devices\/[^/]+\/_challenge(\?.*)?$/,
        request: 'POST /api/v1/saas/auth/mfa/devices/{device_id}/_challenge',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/saas\/auth\/mfa\/devices\/[^/]+\/_challenge_factor(\?.*)?$/,
        request: 'POST /api/v1/saas/auth/mfa/devices/{device_id}/_challenge_factor',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/saas\/auth\/mfa\/devices\/[^/]+\/_verify_challenge(\?.*)?$/,
        request: 'POST /api/v1/saas/auth/mfa/devices/{device_id}/_verify_challenge',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/saas\/auth\/mfa\/devices\/[^/]+\/_verify_factor(\?.*)?$/,
        request: 'POST /api/v1/saas/auth/mfa/devices/{device_id}/_verify_factor',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/saas\/billing\/[^/]+\/_credit(\?.*)?$/,
        request: 'POST /api/v1/saas/billing/{organization_id}/_credit',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/saas\/billing\/[^/]+\/_retry_past_due_invoices(\?.*)?$/,
        request: 'POST /api/v1/saas/billing/{organization_id}/_retry_past_due_invoices',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/saas\/billing\/[^/]+\/_set_to_direct(\?.*)?$/,
        request: 'POST /api/v1/saas/billing/{organization_id}/_set_to_direct',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/saas\/launchdarkly\/[^/]+\/evaluate_feature_flag(\?.*)?$/,
        request:
          'POST /api/v1/regions/{region_id}/saas/launchdarkly/{context_key}/evaluate_feature_flag',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/regions\/[^/]+\/saas\/launchdarkly\/[^/]+\/track_event(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/saas/launchdarkly/{context_key}/track_event',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/regions\/[^/]+\/saas\/legacy\/usage-events\/data-tier(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/saas/legacy/usage-events/data-tier',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/regions\/[^/]+\/saas\/legacy\/usage-events\/disk(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/saas/legacy/usage-events/disk',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/saas\/legacy\/usage-events\/failed-autoscale(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/saas/legacy/usage-events/failed-autoscale',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/saas\/legacy\/usage-events\/machine-learning(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/saas/legacy/usage-events/machine-learning',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/regions\/[^/]+\/saas\/marketplace\/_deactivate(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/saas/marketplace/_deactivate',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/saas\/organizations\/[^/]+\/_add_to_serverless_waitlist(\?.*)?$/,
        request: 'POST /api/v1/saas/organizations/{organization_id}/_add_to_serverless_waitlist',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/saas\/organizations\/[^/]+\/_convert_from_trial(\?.*)?$/,
        request: 'POST /api/v1/saas/organizations/{organization_id}/_convert_from_trial',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/saas\/organizations\/[^/]+\/_extend_trial(\?.*)?$/,
        request: 'POST /api/v1/saas/organizations/{organization_id}/_extend_trial',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/saas\/organizations\/[^/]+\/_regenerate_invoices(\?.*)?$/,
        request: 'POST /api/v1/saas/organizations/{organization_id}/_regenerate_invoices',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/regions\/[^/]+\/saas\/portal\/checkout\/_callback(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/saas/portal/checkout/_callback',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/saas\/users\/[^/]+\/authorization\/_check(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/saas/users/{user_ids}/authorization/_check',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/saas\/users\/[^/]+\/_request_deletion(\?.*)?$/,
        request: 'POST /api/v1/saas/users/{user_id}/_request_deletion',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/saas\/users\/[^/]+\/_scrub(\?.*)?$/,
        request: 'POST /api/v1/saas/users/{user_id}/_scrub',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/saas\/users\/[^/]+\/auth\/mfa\/devices(\?.*)?$/,
        request: 'POST /api/v1/saas/users/{user_id}/auth/mfa/devices',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/saas\/users\/[^/]+\/auth\/okta\/groups\/[^/]+(\?.*)?$/,
        request: 'POST /api/v1/saas/users/{user_id}/auth/okta/groups/{group_name}',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/saas\/users\/[^/]+\/mfa\/_reset(\?.*)?$/,
        request: 'POST /api/v1/saas/users/{user_id}/mfa/_reset',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/regions\/[^/]+\/stack\/versions(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/stack/versions',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/regions\/[^/]+\/stack\/versions\/access(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/stack/versions/access',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/regions\/[^/]+\/stack\/versions\/access\/blacklisted-upgrades(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/stack/versions/access/blacklisted-upgrades',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/regions\/[^/]+\/users\/auth\/_login(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/users/auth/_login',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/regions\/[^/]+\/users\/auth\/saml\/_callback(\?.*)?$/,
        request: 'POST /api/v1/regions/{region_id}/users/auth/saml/_callback',
        service: 'cp',
      },
      {
        pattern: /^POST \/api\/v1\/users\/[^/]+\/role_assignments(\?.*)?$/,
        request: 'POST /api/v1/users/{user_id}/role_assignments',
        service: 'cp',
      },
      {
        pattern:
          /^POST \/api\/v1\/serverless\/projects\/elasticsearch\/[^/]+\/_reset-credentials(\?.*)?$/,
        request: 'POST /api/v1/serverless/projects/elasticsearch/{id}/_reset-credentials',
        service: 'project',
      },
      {
        pattern:
          /^POST \/api\/v1\/serverless\/projects\/elasticsearch\/[^/]+\/_reset-internal-credentials(\?.*)?$/,
        request: 'POST /api/v1/serverless/projects/elasticsearch/{id}/_reset-internal-credentials',
        service: 'project',
      },
      {
        pattern: /^POST \/api\/v1\/serverless\/projects\/elasticsearch\/[^/]+\/_resume(\?.*)?$/,
        request: 'POST /api/v1/serverless/projects/elasticsearch/{id}/_resume',
        service: 'project',
      },
      {
        pattern:
          /^POST \/api\/v1\/serverless\/projects\/observability\/[^/]+\/_reset-credentials(\?.*)?$/,
        request: 'POST /api/v1/serverless/projects/observability/{id}/_reset-credentials',
        service: 'project',
      },
      {
        pattern:
          /^POST \/api\/v1\/serverless\/projects\/observability\/[^/]+\/_reset-internal-credentials(\?.*)?$/,
        request: 'POST /api/v1/serverless/projects/observability/{id}/_reset-internal-credentials',
        service: 'project',
      },
      {
        pattern: /^POST \/api\/v1\/serverless\/projects\/observability\/[^/]+\/_resume(\?.*)?$/,
        request: 'POST /api/v1/serverless/projects/observability/{id}/_resume',
        service: 'project',
      },
      {
        pattern:
          /^POST \/api\/v1\/serverless\/projects\/security\/[^/]+\/_reset-credentials(\?.*)?$/,
        request: 'POST /api/v1/serverless/projects/security/{id}/_reset-credentials',
        service: 'project',
      },
      {
        pattern:
          /^POST \/api\/v1\/serverless\/projects\/security\/[^/]+\/_reset-internal-credentials(\?.*)?$/,
        request: 'POST /api/v1/serverless/projects/security/{id}/_reset-internal-credentials',
        service: 'project',
      },
      {
        pattern: /^POST \/api\/v1\/serverless\/projects\/security\/[^/]+\/_resume(\?.*)?$/,
        request: 'POST /api/v1/serverless/projects/security/{id}/_resume',
        service: 'project',
      },
      {
        pattern: /^POST \/api\/v1\/billing\/organization\/[^/]+\/used_csps(\?.*)?$/,
        request: 'POST /api/v1/billing/organization/{organization_ids}/used_csps',
        service: 'billing',
      },
      {
        pattern: /^POST \/api\/v1\/billing\/organization\/[^/]+\/charge(\?.*)?$/,
        request: 'POST /api/v1/billing/organization/{organization_id}/charge',
        service: 'billing',
      },
      {
        pattern: /^POST \/api\/v1\/billing\/organization\/[^/]+\/check(\?.*)?$/,
        request: 'POST /api/v1/billing/organization/{organization_id}/check',
        service: 'billing',
      },
      {
        pattern: /^POST \/api\/v1\/billing\/organization\/[^/]+\/credit(\?.*)?$/,
        request: 'POST /api/v1/billing/organization/{organization_id}/credit',
        service: 'billing',
      },
      {
        pattern: /^POST \/api\/v1\/billing\/organization\/[^/]+\/invoice\/[^/]+(\?.*)?$/,
        request: 'POST /api/v1/billing/organization/{organization_id}/invoice/{invoice_id}',
        service: 'billing',
      },
      {
        pattern: /^POST \/api\/v1\/billing\/organization\/[^/]+\/invoice\/[^/]+\/event(\?.*)?$/,
        request: 'POST /api/v1/billing/organization/{organization_id}/invoice/{invoice_id}/event',
        service: 'billing',
      },
      {
        pattern:
          /^POST \/api\/v1\/billing\/organization\/[^/]+\/invoice\/[^/]+\/payment_status(\?.*)?$/,
        request:
          'POST /api/v1/billing/organization/{organization_id}/invoice/{invoice_id}/payment_status',
        service: 'billing',
      },
      {
        pattern:
          /^POST \/api\/v1\/billing\/organization\/[^/]+\/invoice\/[^/]+\/regenerate_external_invoice(\?.*)?$/,
        request:
          'POST /api/v1/billing/organization/{organization_id}/invoice/{invoice_id}/regenerate_external_invoice',
        service: 'billing',
      },
      {
        pattern: /^POST \/api\/v1\/billing\/organization\/[^/]+\/set_to_direct(\?.*)?$/,
        request: 'POST /api/v1/billing/organization/{organization_id}/set_to_direct',
        service: 'billing',
      },
      {
        pattern: /^POST \/api\/v1\/billing\/organization\/[^/]+\/trial(\?.*)?$/,
        request: 'POST /api/v1/billing/organization/{organization_id}/trial',
        service: 'billing',
      },
      {
        pattern: /^POST \/api\/v1\/billing\/organizations\/[^/]+\/scrub(\?.*)?$/,
        request: 'POST /api/v1/billing/organizations/{organization_id}/scrub',
        service: 'billing',
      },
      {
        pattern: /^POST \/api\/v1\/billing\/recurly\/organization\/[^/]+\/billing_info(\?.*)?$/,
        request: 'POST /api/v1/billing/recurly/organization/{organization_id}/billing_info',
        service: 'billing',
      },
      {
        pattern: /^POST \/api\/v1\/billing\/util\/[^/]+\/deprovision(\?.*)?$/,
        request: 'POST /api/v1/billing/util/{organization_id}/deprovision',
        service: 'billing',
      },
      {
        pattern: /^POST \/api\/v1\/billing\/util\/[^/]+\/ledger\/complete(\?.*)?$/,
        request: 'POST /api/v1/billing/util/{organization_id}/ledger/complete',
        service: 'billing',
      },
      {
        pattern: /^POST \/api\/v1\/billing\/util\/[^/]+\/recalculate(\?.*)?$/,
        request: 'POST /api/v1/billing/util/{organization_id}/recalculate',
        service: 'billing',
      },
      {
        pattern: /^POST \/api\/v1\/marketplace\/aws\/[^/]+\/contracts\/[^/]+\/overage(\?.*)?$/,
        request: 'POST /api/v1/marketplace/aws/{organization_id}/contracts/{contract}/overage',
        service: 'billing',
      },
      {
        pattern: /^POST \/api\/v1\/marketplace\/azure\/[^/]+\/subscription(\?.*)?$/,
        request: 'POST /api/v1/marketplace/azure/{organization_id}/subscription',
        service: 'billing',
      },
      {
        pattern: /^POST \/api\/v1\/marketplace\/azure\/[^/]+\/contracts\/[^/]+\/overage(\?.*)?$/,
        request: 'POST /api/v1/marketplace/azure/{user_id}/contracts/{contract}/overage',
        service: 'billing',
      },
    ],
    PUT: [
      {
        pattern: /^PUT \/api\/v1\/regions\/[^/]+\/aliases\/[^/]+\/transfer(\?.*)?$/,
        request: 'PUT /api/v1/regions/{region_id}/aliases/{alias}/transfer',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/regions\/[^/]+\/comments\/[^/]+\/[^/]+\/[^/]+(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/comments/{resource_type}/{resource_id}/{comment_id}',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/deployments\/extensions\/[^/]+(\?.*)?$/,
        request: 'PUT /api/v1/deployments/extensions/{extension_id}',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/deployments\/templates\/[^/]+(\?.*)?$/,
        request: 'PUT /api/v1/deployments/templates/{template_id}',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/deployments\/traffic-filter\/rulesets\/[^/]+(\?.*)?$/,
        request: 'PUT /api/v1/deployments/traffic-filter/rulesets/{ruleset_id}',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/deployments\/[^/]+(\?.*)?$/,
        request: 'PUT /api/v1/deployments/{deployment_id}',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/deployments\/[^/]+\/appsearch\/[^/]+\/read_only_mode(\?.*)?$/,
        request: 'PUT /api/v1/deployments/{deployment_id}/appsearch/{ref_id}/read_only_mode',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/deployments\/[^/]+\/elasticsearch\/[^/]+\/remote-clusters(\?.*)?$/,
        request: 'PUT /api/v1/deployments/{deployment_id}/elasticsearch/{ref_id}/remote-clusters',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/deployments\/[^/]+\/elasticsearch\/[^/]+\/users\/[^/]+(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/deployments/{deployment_id}/elasticsearch/{ref_id}/users/{user_name}',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/instances\/overrides(\?.*)?$/,
        request:
          'PUT /api/v1/deployments/{deployment_id}/{resource_kind}/{ref_id}/instances/overrides',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/instances\/[^/]+\/overrides(\?.*)?$/,
        request:
          'PUT /api/v1/deployments/{deployment_id}/{resource_kind}/{ref_id}/instances/{instance_ids}/overrides',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/proxy\/.*(\?.*)?$/,
        request:
          'PUT /api/v1/deployments/{deployment_id}/{resource_kind}/{ref_id}/proxy/{proxy_path}',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/organizations\/[^/]+(\?.*)?$/,
        request: 'PUT /api/v1/organizations/{organization_id}',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/organizations\/[^/]+\/configuration(\?.*)?$/,
        request: 'PUT /api/v1/organizations/{organization_id}/configuration',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/organizations\/[^/]+\/idp(\?.*)?$/,
        request: 'PUT /api/v1/organizations/{organization_id}/idp',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/organizations\/[^/]+\/role_mappings(\?.*)?$/,
        request: 'PUT /api/v1/organizations/{organization_id}/role_mappings',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/configuration\/feature-flags\/[^/]+(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/configuration/feature-flags/{feature_flag}',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/configuration\/instances\/[^/]+(\?.*)?$/,
        request: 'PUT /api/v1/regions/{region_id}/platform/configuration/instances/{id}',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/configuration\/networking\/deployment_domain_name(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/configuration/networking/deployment_domain_name',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/configuration\/networking\/deployment_domain_name\/[^/]+(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/configuration/networking/deployment_domain_name/{resource_kind}',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/deployment(\?.*)?$/,
        request: 'PUT /api/v1/regions/{region_id}/platform/configuration/security/deployment',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/extra_certs\/[^/]+(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/configuration/security/extra_certs/{cert_id}',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/realms\/active-directory\/[^/]+(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/configuration/security/realms/active-directory/{realm_id}',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/realms\/ldap\/[^/]+(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/configuration/security/realms/ldap/{realm_id}',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/realms\/saml\/[^/]+(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/configuration/security/realms/saml/{realm_id}',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/configuration\/shared-files\/[^/]+(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/configuration/shared-files/{shared_file}',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/configuration\/snapshots\/repositories\/[^/]+(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/configuration/snapshots/repositories/{repository_name}',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/regions\/[^/]+\/platform\/configuration\/store\/[^/]+(\?.*)?$/,
        request: 'PUT /api/v1/regions/{region_id}/platform/configuration/store/{config_option_id}',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/configuration\/trust-relationships\/[^/]+(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/configuration/trust-relationships/{trust_relationship_id}',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/adminconsoles\/[^/]+\/logging_settings(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/infrastructure/adminconsoles/{adminconsole_id}/logging_settings',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/allocators\/[^/]+\/logging_settings(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/infrastructure/allocators/{allocator_id}/logging_settings',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/allocators\/[^/]+\/metadata(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/infrastructure/allocators/{allocator_id}/metadata',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/allocators\/[^/]+\/metadata\/[^/]+(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/infrastructure/allocators/{allocator_id}/metadata/{key}',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/allocators\/[^/]+\/settings(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/infrastructure/allocators/{allocator_id}/settings',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/blueprinter\/roles\/[^/]+(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/infrastructure/blueprinter/roles/{blueprinter_role_id}',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/blueprinter\/roles\/[^/]+\/blessings(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/infrastructure/blueprinter/roles/{blueprinter_role_id}/blessings',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/blueprinter\/roles\/[^/]+\/blessings\/[^/]+(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/infrastructure/blueprinter/roles/{blueprinter_role_id}/blessings/{runner_id}',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/constructors\/[^/]+\/logging_settings(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/infrastructure/constructors/{constructor_id}/logging_settings',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/proxies\/filtered-groups\/[^/]+(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/infrastructure/proxies/filtered-groups/{proxies_filtered_group_id}',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/proxies\/settings(\?.*)?$/,
        request: 'PUT /api/v1/regions/{region_id}/platform/infrastructure/proxies/settings',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/runners\/[^/]+\/logging_settings(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/infrastructure/runners/{runner_id}/logging_settings',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/runners\/[^/]+\/roles(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/infrastructure/runners/{runner_id}/roles',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/regions\/[^/]+\/platform\/license(\?.*)?$/,
        request: 'PUT /api/v1/regions/{region_id}/platform/license',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/platform\/resources\/aws\/s3\/accounts\/[^/]+(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/platform/resources/aws/s3/accounts/{account_name}',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/saas\/auth\/mfa\/devices\/[^/]+(\?.*)?$/,
        request: 'PUT /api/v1/saas/auth/mfa/devices/{device_id}',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/saas\/billing\/[^/]+\/_deactivate(\?.*)?$/,
        request: 'PUT /api/v1/saas/billing/{organization_id}/_deactivate',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/saas\/billing\/[^/]+\/activate(\?.*)?$/,
        request: 'PUT /api/v1/saas/billing/{organization_id}/activate',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/saas\/billing\/[^/]+\/set_payment_method(\?.*)?$/,
        request: 'PUT /api/v1/saas/billing/{organization_id}/set_payment_method',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/saas\/organizations\/[^/]+\/_update_subscription_level(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/saas/organizations/{organization_id}/_update_subscription_level',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/saas\/users\/[^/]+\/auth\/mfa(\?.*)?$/,
        request: 'PUT /api/v1/saas/users/{user_id}/auth/mfa',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/saas\/users\/[^/]+\/auth\/mfa\/devices\/[^/]+(\?.*)?$/,
        request: 'PUT /api/v1/saas/users/{user_id}/auth/mfa/devices/{device_id}',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/saas\/users\/[^/]+\/profile(\?.*)?$/,
        request: 'PUT /api/v1/saas/users/{user_id}/profile',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/stack\/versions\/access\/blacklisted-upgrades\/[^/]+\/[^/]+(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/stack/versions/access/blacklisted-upgrades/{from_version_matcher}/{to_version_matcher}',
        service: 'cp',
      },
      {
        pattern:
          /^PUT \/api\/v1\/regions\/[^/]+\/stack\/versions\/access\/organizations\/[^/]+(\?.*)?$/,
        request:
          'PUT /api/v1/regions/{region_id}/stack/versions/access/organizations/{organization_id}',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/regions\/[^/]+\/stack\/versions\/access\/[^/]+(\?.*)?$/,
        request: 'PUT /api/v1/regions/{region_id}/stack/versions/access/{version}',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/regions\/[^/]+\/stack\/versions\/[^/]+(\?.*)?$/,
        request: 'PUT /api/v1/regions/{region_id}/stack/versions/{version}',
        service: 'cp',
      },
      {
        pattern: /^PUT \/api\/v1\/admin\/marketplace\/azure\/[^/]+\/enable_conversion(\?.*)?$/,
        request: 'PUT /api/v1/admin/marketplace/azure/{organization_id}/enable_conversion',
        service: 'billing',
      },
      {
        pattern: /^PUT \/api\/v1\/billing\/organization\/[^/]+\/activate(\?.*)?$/,
        request: 'PUT /api/v1/billing/organization/{organization_id}/activate',
        service: 'billing',
      },
      {
        pattern: /^PUT \/api\/v1\/billing\/organization\/[^/]+\/deactivate(\?.*)?$/,
        request: 'PUT /api/v1/billing/organization/{organization_id}/deactivate',
        service: 'billing',
      },
      {
        pattern: /^PUT \/api\/v1\/billing\/organization\/[^/]+\/set_payment_method(\?.*)?$/,
        request: 'PUT /api/v1/billing/organization/{organization_id}/set_payment_method',
        service: 'billing',
      },
      {
        pattern: /^PUT \/api\/v1\/billing\/organizations\/[^/]+\/update_account(\?.*)?$/,
        request: 'PUT /api/v1/billing/organizations/{organization_id}/update_account',
        service: 'billing',
      },
      {
        pattern: /^PUT \/api\/v1\/billing\/util\/[^/]+\/[^/]+\/set_internal(\?.*)?$/,
        request: 'PUT /api/v1/billing/util/{report_type}/{report_id}/set_internal',
        service: 'billing',
      },
      {
        pattern: /^PUT \/api\/v1\/marketplace\/azure\/[^/]+\/contracts(\?.*)?$/,
        request: 'PUT /api/v1/marketplace/azure/{user_id}/contracts',
        service: 'billing',
      },
      {
        pattern: /^PUT \/api\/v1\/marketplace\/gcp\/[^/]+\/entitlement(\?.*)?$/,
        request: 'PUT /api/v1/marketplace/gcp/{user_id}/entitlement',
        service: 'billing',
      },
      {
        pattern: /^PUT \/api\/v1\/marketplace\/gcp\/[^/]+\/project(\?.*)?$/,
        request: 'PUT /api/v1/marketplace/gcp/{user_id}/project',
        service: 'billing',
      },
    ],
    DELETE: [
      {
        pattern: /^DELETE \/api\/v1\/regions\/[^/]+\/comments\/[^/]+\/[^/]+\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/comments/{resource_type}/{resource_id}/{comment_id}',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/deployments\/extensions\/[^/]+(\?.*)?$/,
        request: 'DELETE /api/v1/deployments/extensions/{extension_id}',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/deployments\/templates\/[^/]+(\?.*)?$/,
        request: 'DELETE /api/v1/deployments/templates/{template_id}',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/deployments\/traffic-filter\/rulesets\/[^/]+(\?.*)?$/,
        request: 'DELETE /api/v1/deployments/traffic-filter/rulesets/{ruleset_id}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/deployments\/traffic-filter\/rulesets\/[^/]+\/associations\/[^/]+\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/deployments/traffic-filter/rulesets/{ruleset_id}/associations/{association_type}/{associated_entity_id}',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/deployments\/[^/]+(\?.*)?$/,
        request: 'DELETE /api/v1/deployments/{deployment_id}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/deployments\/[^/]+\/elasticsearch\/[^/]+\/snapshot\/dependency\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/deployments/{deployment_id}/elasticsearch/{ref_id}/snapshot/dependency/{resource_id}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/deployments\/[^/]+\/elasticsearch\/[^/]+\/users\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/deployments/{deployment_id}/elasticsearch/{ref_id}/users/{user_name}',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/plan\/pending(\?.*)?$/,
        request: 'DELETE /api/v1/deployments/{deployment_id}/{resource_kind}/{ref_id}/plan/pending',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+\/proxy\/.*(\?.*)?$/,
        request:
          'DELETE /api/v1/deployments/{deployment_id}/{resource_kind}/{ref_id}/proxy/{proxy_path}',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/deployments\/[^/]+\/[^/]+\/[^/]+(\?.*)?$/,
        request: 'DELETE /api/v1/deployments/{deployment_id}/{stateless_resource_kind}/{ref_id}',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/organizations\/[^/]+(\?.*)?$/,
        request: 'DELETE /api/v1/organizations/{organization_id}',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/regions\/[^/]+\/organizations\/[^/]+\/audit_logs(\?.*)?$/,
        request: 'DELETE /api/v1/regions/{region_id}/organizations/{organization_id}/audit_logs',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/organizations\/[^/]+\/domains(\?.*)?$/,
        request: 'DELETE /api/v1/organizations/{organization_id}/domains',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/regions\/[^/]+\/organizations\/[^/]+\/idp(\?.*)?$/,
        request: 'DELETE /api/v1/regions/{region_id}/organizations/{organization_id}/idp',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/organizations\/[^/]+\/invitations\/[^/]+(\?.*)?$/,
        request: 'DELETE /api/v1/organizations/{organization_id}/invitations/{invitation_tokens}',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/organizations\/[^/]+\/members\/[^/]+(\?.*)?$/,
        request: 'DELETE /api/v1/organizations/{organization_id}/members/{user_ids}',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/organizations\/[^/]+\/role_mappings(\?.*)?$/,
        request: 'DELETE /api/v1/organizations/{organization_id}/role_mappings',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/configuration\/azure\/privatelink\/linkids\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/configuration/azure/privatelink/linkids/{name-and-id}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/configuration\/instances\/[^/]+(\?.*)?$/,
        request: 'DELETE /api/v1/regions/{region_id}/platform/configuration/instances/{id}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/enrollment-tokens\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/configuration/security/enrollment-tokens/{token}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/extra_certs\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/configuration/security/extra_certs/{cert_id}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/realms\/active-directory\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/configuration/security/realms/active-directory/{realm_id}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/realms\/ldap\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/configuration/security/realms/ldap/{realm_id}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/realms\/saml\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/configuration/security/realms/saml/{realm_id}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/service-accounts\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/configuration/security/service-accounts/{user_id}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/service-accounts\/[^/]+\/keys\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/configuration/security/service-accounts/{user_id}/keys/{api_key_id}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/configuration\/shared-files\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/configuration/shared-files/{shared_file}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/configuration\/snapshots\/repositories\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/configuration/snapshots/repositories/{repository_name}',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/configuration\/store\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/configuration/store/{config_option_id}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/configuration\/trust-relationships\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/configuration/trust-relationships/{trust_relationship_id}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/adminconsoles\/[^/]+\/logging_settings(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/infrastructure/adminconsoles/{adminconsole_id}/logging_settings',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/allocators\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/infrastructure/allocators/{allocator_id}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/allocators\/[^/]+\/logging_settings(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/infrastructure/allocators/{allocator_id}/logging_settings',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/allocators\/[^/]+\/metadata\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/infrastructure/allocators/{allocator_id}/metadata/{key}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/blueprinter\/roles\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/infrastructure/blueprinter/roles/{blueprinter_role_id}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/constructors\/[^/]+\/logging_settings(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/infrastructure/constructors/{constructor_id}/logging_settings',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/container-sets\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/infrastructure/container-sets/{containerset_id}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/container-sets\/[^/]+\/containers\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/infrastructure/container-sets/{containerset_id}/containers/{container_id}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/coordinators\/candidates\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/infrastructure/coordinators/candidates/{coordinator_candidate_id}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/proxies\/filtered-groups\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/infrastructure/proxies/filtered-groups/{proxies_filtered_group_id}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/runners\/[^/]+(\?.*)?$/,
        request: 'DELETE /api/v1/regions/{region_id}/platform/infrastructure/runners/{runner_id}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/runners\/[^/]+\/logging_settings(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/infrastructure/runners/{runner_id}/logging_settings',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/license(\?.*)?$/,
        request: 'DELETE /api/v1/regions/{region_id}/platform/license',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/platform\/resources\/aws\/s3\/accounts\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/platform/resources/aws/s3/accounts/{account_name}',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/saas\/auth\/mfa\/devices\/[^/]+(\?.*)?$/,
        request: 'DELETE /api/v1/saas/auth/mfa/devices/{device_id}',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/saas\/users\/[^/]+\/auth\/mfa\/devices\/[^/]+(\?.*)?$/,
        request: 'DELETE /api/v1/saas/users/{user_id}/auth/mfa/devices/{device_id}',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/saas\/users\/[^/]+\/email\/[^/]+\/suppressions(\?.*)?$/,
        request: 'DELETE /api/v1/saas/users/{user_id}/email/{email_domain}/suppressions',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/stack\/versions\/access\/blacklisted-upgrades\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/stack/versions/access/blacklisted-upgrades/{from_version_matcher}',
        service: 'cp',
      },
      {
        pattern:
          /^DELETE \/api\/v1\/regions\/[^/]+\/stack\/versions\/access\/blacklisted-upgrades\/[^/]+\/[^/]+(\?.*)?$/,
        request:
          'DELETE /api/v1/regions/{region_id}/stack/versions/access/blacklisted-upgrades/{from_version_matcher}/{to_version_matcher}',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/regions\/[^/]+\/stack\/versions\/access\/[^/]+(\?.*)?$/,
        request: 'DELETE /api/v1/regions/{region_id}/stack/versions/access/{version}',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/regions\/[^/]+\/stack\/versions\/[^/]+(\?.*)?$/,
        request: 'DELETE /api/v1/regions/{region_id}/stack/versions/{version}',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/users\/auth\/keys\/[^/]+(\?.*)?$/,
        request: 'DELETE /api/v1/users/auth/keys/{api_key_id}',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/regions\/[^/]+\/users\/[^/]+\/auth\/keys(\?.*)?$/,
        request: 'DELETE /api/v1/regions/{region_id}/users/{user_id}/auth/keys',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/regions\/[^/]+\/users\/[^/]+\/auth\/keys\/[^/]+(\?.*)?$/,
        request: 'DELETE /api/v1/regions/{region_id}/users/{user_id}/auth/keys/{api_key_id}',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/users\/[^/]+\/role_assignments(\?.*)?$/,
        request: 'DELETE /api/v1/users/{user_id}/role_assignments',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/users\/[^/]+(\?.*)?$/,
        request: 'DELETE /api/v1/users/{user_name}',
        service: 'cp',
      },
      {
        pattern: /^DELETE \/api\/v1\/serverless\/projects\/elasticsearch\/[^/]+(\?.*)?$/,
        request: 'DELETE /api/v1/serverless/projects/elasticsearch/{id}',
        service: 'project',
      },
      {
        pattern: /^DELETE \/api\/v1\/serverless\/projects\/observability\/[^/]+(\?.*)?$/,
        request: 'DELETE /api/v1/serverless/projects/observability/{id}',
        service: 'project',
      },
      {
        pattern: /^DELETE \/api\/v1\/serverless\/projects\/security\/[^/]+(\?.*)?$/,
        request: 'DELETE /api/v1/serverless/projects/security/{id}',
        service: 'project',
      },
    ],
    PATCH: [
      {
        pattern: /^PATCH \/api\/v1\/deployments\/[^/]+\/elasticsearch\/[^/]+\/keystore(\?.*)?$/,
        request: 'PATCH /api/v1/deployments/{deployment_id}/elasticsearch/{ref_id}/keystore',
        service: 'cp',
      },
      {
        pattern:
          /^PATCH \/api\/v1\/regions\/[^/]+\/deployments\/[^/]+\/[^/]+\/[^/]+\/metadata\/raw(\?.*)?$/,
        request:
          'PATCH /api/v1/regions/{region_id}/deployments/{deployment_id}/{resource_kind}/{ref_id}/metadata/raw',
        service: 'cp',
      },
      {
        pattern: /^PATCH \/api\/v1\/organizations\/[^/]+(\?.*)?$/,
        request: 'PATCH /api/v1/organizations/{organization_id}',
        service: 'cp',
      },
      {
        pattern: /^PATCH \/api\/v1\/organizations\/[^/]+\/configuration(\?.*)?$/,
        request: 'PATCH /api/v1/organizations/{organization_id}/configuration',
        service: 'cp',
      },
      {
        pattern:
          /^PATCH \/api\/v1\/regions\/[^/]+\/platform\/configuration\/security\/service-accounts\/[^/]+(\?.*)?$/,
        request:
          'PATCH /api/v1/regions/{region_id}/platform/configuration/security/service-accounts/{user_id}',
        service: 'cp',
      },
      {
        pattern:
          /^PATCH \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/adminconsoles\/[^/]+\/logging_settings(\?.*)?$/,
        request:
          'PATCH /api/v1/regions/{region_id}/platform/infrastructure/adminconsoles/{adminconsole_id}/logging_settings',
        service: 'cp',
      },
      {
        pattern:
          /^PATCH \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/allocators\/[^/]+\/logging_settings(\?.*)?$/,
        request:
          'PATCH /api/v1/regions/{region_id}/platform/infrastructure/allocators/{allocator_id}/logging_settings',
        service: 'cp',
      },
      {
        pattern:
          /^PATCH \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/allocators\/[^/]+\/settings(\?.*)?$/,
        request:
          'PATCH /api/v1/regions/{region_id}/platform/infrastructure/allocators/{allocator_id}/settings',
        service: 'cp',
      },
      {
        pattern:
          /^PATCH \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/constructors\/[^/]+\/logging_settings(\?.*)?$/,
        request:
          'PATCH /api/v1/regions/{region_id}/platform/infrastructure/constructors/{constructor_id}/logging_settings',
        service: 'cp',
      },
      {
        pattern:
          /^PATCH \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/container-sets\/[^/]+\/containers\/[^/]+(\?.*)?$/,
        request:
          'PATCH /api/v1/regions/{region_id}/platform/infrastructure/container-sets/{containerset_id}/containers/{container_id}',
        service: 'cp',
      },
      {
        pattern:
          /^PATCH \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/proxies\/settings(\?.*)?$/,
        request: 'PATCH /api/v1/regions/{region_id}/platform/infrastructure/proxies/settings',
        service: 'cp',
      },
      {
        pattern:
          /^PATCH \/api\/v1\/regions\/[^/]+\/platform\/infrastructure\/runners\/[^/]+\/logging_settings(\?.*)?$/,
        request:
          'PATCH /api/v1/regions/{region_id}/platform/infrastructure/runners/{runner_id}/logging_settings',
        service: 'cp',
      },
      {
        pattern: /^PATCH \/api\/v1\/regions\/[^/]+\/stack\/versions\/access(\?.*)?$/,
        request: 'PATCH /api/v1/regions/{region_id}/stack/versions/access',
        service: 'cp',
      },
      {
        pattern: /^PATCH \/api\/v1\/users\/[^/]+(\?.*)?$/,
        request: 'PATCH /api/v1/users/{user_name}',
        service: 'cp',
      },
      {
        pattern: /^PATCH \/api\/v1\/serverless\/projects\/elasticsearch\/[^/]+(\?.*)?$/,
        request: 'PATCH /api/v1/serverless/projects/elasticsearch/{id}',
        service: 'project',
      },
      {
        pattern: /^PATCH \/api\/v1\/serverless\/projects\/observability\/[^/]+(\?.*)?$/,
        request: 'PATCH /api/v1/serverless/projects/observability/{id}',
        service: 'project',
      },
      {
        pattern: /^PATCH \/api\/v1\/serverless\/projects\/security\/[^/]+(\?.*)?$/,
        request: 'PATCH /api/v1/serverless/projects/security/{id}',
        service: 'project',
      },
      {
        pattern: /^PATCH \/api\/v1\/admin\/billing\/organization\/[^/]+\/trial(\?.*)?$/,
        request: 'PATCH /api/v1/admin/billing/organization/{organization_id}/trial',
        service: 'billing',
      },
      {
        pattern:
          /^PATCH \/api\/v1\/billing\/organization\/[^/]+\/line_items\/activate\/[^/]+(\?.*)?$/,
        request:
          'PATCH /api/v1/billing/organization/{organization_id}/line_items/activate/{activation_code}',
        service: 'billing',
      },
      {
        pattern: /^PATCH \/api\/v1\/billing\/organization\/[^/]+\/trial(\?.*)?$/,
        request: 'PATCH /api/v1/billing/organization/{organization_id}/trial',
        service: 'billing',
      },
    ],
  },
}

export const testStaticRequest = { request: 'GET /api/v1/account', service: 'cp' }

export const testDynamicRequest = {
  pattern: /^GET \/api\/v1\/regions\/[^/]+\/aliases\/[^/]+(\?.*)?$/,
  request: 'GET /api/v1/regions/{region_id}/aliases/{alias}',
}
